import Icon from 'veui/components/Icon'
import { IconBullseye } from 'dls-icons-vue'

Icon.register('bullseye', IconBullseye)
